import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { CONTACT_EMAIL } from '../config/contact';
import './Navbar.css';

const Navbar = ({ section }) => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavigation = (e, path) => {
    e.preventDefault();
    navigate(path);
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 100);
  };

  const isConsulting = section === 'consulting';
  const basePath = isConsulting ? '/consulting' : '/trading';

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''} ${isConsulting ? 'navbar-consulting' : ''}`}>
      <div className="nav-container">
        <div className="nav-logo" onClick={(e) => handleNavigation(e, basePath)}>
          <img 
            src="/tqs-logo-background-removed.png" 
            alt="TQS Logo" 
            style={{ 
              height: '125px', 
              objectFit: 'contain',
              cursor: 'pointer'
            }} 
          />
          {isConsulting && <span className="nav-subtitle" style={{ marginLeft: '10px', fontWeight: 'bold', color: '#0b1120' }}>Consulting</span>}
          {!isConsulting && section === 'trading' && <span className="nav-subtitle" style={{ marginLeft: '10px', fontWeight: 'bold', color: 'white' }}>Trading</span>}
        </div>

        <div className={`nav-menu ${mobileMenuOpen ? 'active' : ''}`}>
          <Link to={basePath} className="nav-link" onClick={(e) => handleNavigation(e, basePath)}>Home</Link>
          {!isConsulting && (
            <Link to={`${basePath}/careers`} className="nav-link" onClick={(e) => handleNavigation(e, `${basePath}/careers`)}>Careers</Link>
          )}
          <a href={`mailto:${CONTACT_EMAIL}`} className="nav-link">Contact</a>
        </div>

        <button 
          className="mobile-menu-toggle"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
